var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Checkbox',{attrs:{"name":_vm.name,"value":_vm.value,"tooltip":_vm.silenceTooltipConfig},on:{"change":function($event){return _vm.$emit('change', $event)}}},[_vm._v("Не против неловкого молчания")])}
var staticRenderFns = []

export { render, staticRenderFns }